import React, { FormEvent, useMemo, useState } from "react";

import { Link, useLocation, useSearchParams } from "react-router-dom";

import Header from "../components/Header";

import Footer from "../components/Footer";

import {

  contactApi,

  PreferredContactChannel,

} from "../api/contactapi";



import serviceContactImage from "../assets/contact/service-contact.png";

import customerStory01 from "../assets/contact/1.png";
import customerStory02 from "../assets/contact/2.png";
import customerStory03 from "../assets/contact/3.png";
import customerStory04 from "../assets/contact/customer-story-04.jpg";
import customerStory05 from "../assets/contact/5.png";
import customerStory06 from "../assets/contact/customer-story-06.png";

import contactPattern from "../assets/contact/form-pattern.svg";



import "../styles/ContactPage.css";



type ContactFormState = {

  fullName: string;

  phone: string;

  email: string;

  need: string;

  preferredContactChannel: PreferredContactChannel;

  message: string;

};

type FooterContactNavigationState = {
  fromFooter?: boolean;
  email?: string;
};



const HOTLINE_DISPLAY = "0901191141";

const HOTLINE_LINK = "0901191141";

const ZALO_URL = `https://zalo.me/3354373045960365130`;



const needOptions = [

  "Tư vấn chọn sản phẩm",

  "Báo giá sản phẩm",

  "Chọn ngọc theo bản mệnh",

  "Hỏi về kiểm định / nguồn gốc",

  "Đặt lịch xem sản phẩm",

  "Liên hệ khác",

];



const contactChannelOptions: {

  value: PreferredContactChannel;

  label: string;

}[] = [

  { value: "zalo", label: "Zalo" },

  { value: "phone", label: "Điện thoại" },

  { value: "email", label: "Email" },

];




const customerStories = [
  {
    number: "01",
    image: customerStory01,
    alt: "Khách hàng được King Jades hỗ trợ xác nhận thông tin tại bàn tư vấn",
    title: "Lắng nghe nhu cầu trước khi tư vấn",
    text: "Khách hàng được trao đổi kỹ về mong muốn, sản phẩm quan tâm và thông tin cần xác nhận trước khi lựa chọn.",
  },
  {
    number: "02",
    image: customerStory02,
    alt: "Khách hàng trải nghiệm vòng ngọc cùng đội ngũ King Jades tại cửa hàng",
    title: "Trải nghiệm ngọc trực tiếp tại cửa hàng",
    text: "Đội ngũ hỗ trợ khách xem, thử và so sánh nhiều mẫu để cảm nhận màu sắc, kích thước và độ phù hợp.",
  },
  {
    number: "03",
    image: customerStory03,
    alt: "Nhân viên King Jades đồng hành cùng khách hàng lựa chọn sản phẩm",
    title: "Đồng hành chọn mẫu phù hợp",
    text: "Sale King Jades tư vấn trực tiếp, giải đáp thắc mắc và cùng khách cân nhắc mẫu phù hợp với nhu cầu cá nhân.",
  },
  {
    number: "04",
    image: customerStory04,
    alt: "Khách hàng và nhân viên King Jades lưu lại khoảnh khắc sau khi lựa chọn sản phẩm",
    title: "Khoảnh khắc nhận món ngọc đã chọn",
    text: "Niềm vui của khách hàng sau khi hoàn tất quá trình tư vấn và lựa chọn sản phẩm tại King Jades.",
  },
  {
    number: "05",
    image: customerStory05,
    alt: "Đội ngũ King Jades tư vấn khách hàng tại quầy trưng bày",
    title: "Tư vấn tận tình với từng khách hàng",
    text: "Mỗi cuộc trò chuyện đều được tiếp cận rõ ràng, cởi mở để khách dễ xem sản phẩm và đưa ra lựa chọn.",
  },
  {
    number: "06",
    image: customerStory06,
    alt: "Khách hàng hoàn tất thông tin cùng nhân viên tư vấn King Jades",
    title: "Chỉn chu trong từng bước xác nhận",
    text: "Đội ngũ hỗ trợ khách hoàn tất thông tin cần thiết và tiếp tục đồng hành sau buổi tư vấn.",
  },
];

const PhoneIcon = () => (

  <svg viewBox="0 0 24 24" aria-hidden="true">

    <path d="M8.2 3.8 5.8 4.9c-.7.3-1 1.1-.8 1.8 1.8 6.1 6.2 10.5 12.3 12.3.7.2 1.5-.1 1.8-.8l1.1-2.4c.3-.7.1-1.5-.6-1.9l-2.7-1.6c-.6-.3-1.3-.2-1.7.3l-1.2 1.5a14.4 14.4 0 0 1-4.1-4.1l1.5-1.2c.5-.4.6-1.1.3-1.7L10.1 4.4c-.4-.7-1.2-.9-1.9-.6Z" />

  </svg>

);



const MessageIcon = () => (

  <svg viewBox="0 0 24 24" aria-hidden="true">

    <path d="M4 5.5h16v11H9l-5 3v-14Z" />

    <path d="M8 9h8M8 13h5" />

  </svg>

);



const CalendarIcon = () => (

  <svg viewBox="0 0 24 24" aria-hidden="true">

    <rect x="3.5" y="5.5" width="17" height="15" rx="2" />

    <path d="M7.5 3.5v4M16.5 3.5v4M3.5 10h17" />

  </svg>

);



const ArrowIcon = () => (

  <svg viewBox="0 0 24 24" aria-hidden="true">

    <path d="M5 12h14" />

    <path d="m14 7 5 5-5 5" />

  </svg>

);



const ContactPage: React.FC = () => {

  const location = useLocation();

  const footerState =
    (location.state as FooterContactNavigationState | null) || null;

  const footerEmail =
    footerState?.fromFooter
      ? (footerState.email || "").trim()
      : "";

  const [searchParams] = useSearchParams();



  const productId = searchParams.get("productId") || "";

  const productName = searchParams.get("productName") || "";

  const productSlug = searchParams.get("productSlug") || "";



  const source = productId || productName

    ? "product_detail"

    : footerState?.fromFooter

      ? "footer_email"

      : "contact_page";



  const [form, setForm] = useState<ContactFormState>({

    fullName: "",

    phone: "",

    email: footerEmail,

    need: productName

      ? "Báo giá sản phẩm"

      : "Tư vấn chọn sản phẩm",

    preferredContactChannel:
      footerEmail ? "email" : "zalo",

    message: productName

      ? `Tôi muốn được tư vấn và báo giá sản phẩm: ${productName}`

      : "",

  });



  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const [successMessage, setSuccessMessage] = useState("");

  const [sentAt, setSentAt] = useState("");



  const productLink = useMemo(() => {

    if (!productSlug) return "";

    return `/products/${productSlug}`;

  }, [productSlug]);



  const updateField = (

    field: keyof ContactFormState,

    value: string

  ) => {

    setForm((previous) => ({

      ...previous,

      [field]: value,

    }));

  };



  const validateForm = () => {

    if (!form.fullName.trim()) {

      return "Vui lòng nhập họ tên.";

    }



    if (!form.phone.trim()) {

      return "Vui lòng nhập số điện thoại.";

    }



    const normalizedPhone = form.phone.replace(/\s+/g, "");



    if (!/^[0-9+]{9,15}$/.test(normalizedPhone)) {

      return "Số điện thoại chưa đúng định dạng.";

    }



    if (

      form.email.trim() &&

      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())

    ) {

      return "Email chưa đúng định dạng.";

    }



    return "";

  };



  const handleSubmit = async (

    event: FormEvent<HTMLFormElement>

  ) => {

    event.preventDefault();



    const validationMessage = validateForm();



    if (validationMessage) {

      setError(validationMessage);

      setSuccessMessage("");

      return;

    }



    try {

      setLoading(true);

      setError("");

      setSuccessMessage("");

      setSentAt("");



      const data = await contactApi.createContactLead({

        fullName: form.fullName.trim(),

        phone: form.phone.trim(),

        email: form.email.trim(),

        need: form.need,

        preferredContactChannel:

          form.preferredContactChannel,

        message: form.message.trim(),

        productId,

        productName,

        productSlug,

        source,

      });



      setSuccessMessage(

        data.message ||

          "King Jades đã nhận thông tin. Đội ngũ tư vấn sẽ liên hệ lại sớm."

      );



      if (data.lead?.createdAtUtc) {

        setSentAt(data.lead.createdAtUtc);

      }



      setForm((previous) => ({

        ...previous,

        fullName: "",

        phone: "",

        email: "",

        message: productName

          ? `Tôi muốn được tư vấn và báo giá sản phẩm: ${productName}`

          : "",

      }));

    } catch (requestError) {

      const apiError = requestError as Error;



      setError(

        apiError.message ||

          "Không thể gửi thông tin liên hệ lúc này."

      );

    } finally {

      setLoading(false);

    }

  };



  return (

    <>

      <Header />



      <div className="kj-contact-page">

        <main className="kj-contact-main">

          <section className="kj-contact-hero">

            <div

              className="kj-contact-hero__pattern"

              style={{

                backgroundImage: `url(${contactPattern})`,

              }}

              aria-hidden="true"

            />



            <div

              className="kj-contact-hero__glow kj-contact-hero__glow--left"

              aria-hidden="true"

            />

            <div

              className="kj-contact-hero__glow kj-contact-hero__glow--right"

              aria-hidden="true"

            />



            <div className="kj-contact-shell kj-contact-hero__inner">

              <div className="kj-contact-visual">

                <div className="kj-contact-visual__image">

                  <img

                    src={serviceContactImage}

                    alt="Đội ngũ tư vấn King Jades"

                  />



                  <div className="kj-contact-visual__badge">

                    <span>King Jades Service</span>

                    <strong>Tư vấn riêng 1:1</strong>

                  </div>

                </div>



                <div className="kj-contact-visual__floating-card">

                  <span className="kj-contact-eyebrow">

                    Personalized Guidance

                  </span>



                  <h1>

                    Kết nối để chọn đúng món ngọc dành cho bạn.

                  </h1>



                  <p>

                    Đội ngũ King Jades tiếp nhận nhu cầu về

                    sản phẩm, size vòng, màu sắc, kiểm định và

                    tư vấn theo bản mệnh.

                  </p>



                  <div className="kj-contact-visual__quick-actions">

                    <a href={`tel:${HOTLINE_LINK}`}>

                      <PhoneIcon />

                      Gọi {HOTLINE_DISPLAY}

                    </a>



                    <a

                      href={ZALO_URL}

                      target="_blank"

                      rel="noreferrer"

                    >

                      <MessageIcon />

                      Nhắn Zalo

                    </a>

                  </div>

                </div>

              </div>



              <div className="kj-contact-form-card">

                <div className="kj-contact-form-card__heading">

                  <div>

                    <span className="kj-contact-eyebrow">

                      Contact King Jades

                    </span>

                    <h2>Gửi yêu cầu tư vấn</h2>

                    <p>

                      Điền thông tin bên dưới. Đội ngũ tư vấn sẽ

                      liên hệ theo kênh bạn ưu tiên.

                    </p>

                  </div>



                  {productName && (

                    <div className="kj-contact-product-reference">

                      <span>Sản phẩm quan tâm</span>



                      {productLink ? (

                        <Link to={productLink}>

                          {productName}

                        </Link>

                      ) : (

                        <strong>{productName}</strong>

                      )}

                    </div>

                  )}

                </div>



                {successMessage && (

                  <div className="kj-contact-alert kj-contact-alert--success">

                    <strong>{successMessage}</strong>



                    {sentAt && (

                      <span>

                        Gửi lúc:{" "}

                        {new Date(sentAt).toLocaleString(

                          "vi-VN"

                        )}

                      </span>

                    )}

                  </div>

                )}



                {error && (

                  <div className="kj-contact-alert kj-contact-alert--error">

                    {error}

                  </div>

                )}



                <form

                  className="kj-contact-form"

                  onSubmit={handleSubmit}

                  noValidate

                >

                  <div className="kj-contact-form__grid">

                    <label className="kj-contact-field">

                      <span>

                        Họ và tên <b>*</b>

                      </span>

                      <input

                        value={form.fullName}

                        onChange={(event) =>

                          updateField(

                            "fullName",

                            event.target.value

                          )

                        }

                        placeholder="Nhập họ tên"

                        autoComplete="name"

                      />

                    </label>



                    <label className="kj-contact-field">

                      <span>

                        Số điện thoại <b>*</b>

                      </span>

                      <input

                        value={form.phone}

                        onChange={(event) =>

                          updateField(

                            "phone",

                            event.target.value

                          )

                        }

                        placeholder="VD: 0918xxxxxx"

                        inputMode="tel"

                        autoComplete="tel"

                      />

                    </label>



                    <label className="kj-contact-field">

                      <span>Email</span>

                      <input

                        value={form.email}

                        onChange={(event) =>

                          updateField(

                            "email",

                            event.target.value

                          )

                        }

                        placeholder="email\@example.com"

                        type="email"

                        autoComplete="email"

                      />

                    </label>



                    <label className="kj-contact-field">

                      <span>Nhu cầu tư vấn</span>

                      <select

                        value={form.need}

                        onChange={(event) =>

                          updateField(

                            "need",

                            event.target.value

                          )

                        }

                      >

                        {needOptions.map((item) => (

                          <option key={item} value={item}>

                            {item}

                          </option>

                        ))}

                      </select>

                    </label>

                  </div>



                  <fieldset className="kj-contact-channel">

                    <legend>Kênh liên hệ ưu tiên</legend>



                    <div>

                      {contactChannelOptions.map((item) => (

                        <label key={item.value}>

                          <input

                            type="radio"

                            name="preferredContactChannel"

                            value={item.value}

                            checked={

                              form.preferredContactChannel ===

                              item.value

                            }

                            onChange={() =>

                              updateField(

                                "preferredContactChannel",

                                item.value

                              )

                            }

                          />

                          <span>{item.label}</span>

                        </label>

                      ))}

                    </div>

                  </fieldset>



                  <label className="kj-contact-field">

                    <span>Nội dung cần tư vấn</span>

                    <textarea

                      value={form.message}

                      onChange={(event) =>

                        updateField(

                          "message",

                          event.target.value

                        )

                      }

                      rows={5}

                      placeholder="Sản phẩm quan tâm, size cổ tay, màu sắc, ngân sách dự kiến hoặc câu hỏi về kiểm định..."

                    />

                  </label>



                  <button

                    type="submit"

                    className="kj-contact-submit"

                    disabled={loading}

                  >

                    {loading

                      ? "Đang gửi..."

                      : "Gửi yêu cầu tư vấn"}

                    {!loading && <ArrowIcon />}

                  </button>



                

                </form>

              </div>

            </div>

          </section>



          <section className="kj-contact-methods">

            <div className="kj-contact-shell">

              <header className="kj-contact-section-heading">

                <div>

                  <span className="kj-contact-eyebrow">

                    Contact Options

                  </span>

                  <h2>Chọn cách kết nối thuận tiện nhất.</h2>

                </div>



                <p>

                  King Jades hỗ trợ tư vấn trực tiếp qua hotline,

                  Zalo hoặc đặt lịch xem sản phẩm.

                </p></header>



              <div className="kj-contact-methods__grid">

                <article>

                  <span className="kj-contact-methods__icon">

                    <PhoneIcon />

                  </span>

                  <small>Hotline</small>

                  <h3>{HOTLINE_DISPLAY}</h3>

                  <p>

                    Trao đổi nhanh về sản phẩm, size và lịch hẹn.

                  </p>

                  <a href={`tel:${HOTLINE_LINK}`}>

                    Gọi ngay <ArrowIcon />

                  </a>

                </article>



                <article>

                  <span className="kj-contact-methods__icon">

                    <MessageIcon />

                  </span>

                  <small>Zalo tư vấn</small>

                  <h3>Nhắn tin trực tiếp</h3>

                  <p>

                    Gửi hình ảnh hoặc sản phẩm đang quan tâm qua

                    Zalo.

                  </p>

                  <a

                    href={ZALO_URL}

                    target="_blank"

                    rel="noreferrer"

                  >

                    Mở Zalo <ArrowIcon />

                  </a>

                </article>



                <article>

                  <span className="kj-contact-methods__icon">

                    <CalendarIcon />

                  </span>

                  <small>Đặt lịch</small>

                  <h3>Xem sản phẩm 1:1</h3>

                  <p>

                    Đặt trước thời gian để đội ngũ chuẩn bị sản

                    phẩm phù hợp.

                  </p>

                  <Link to="/contact">

                    Đặt lịch tư vấn <ArrowIcon />

                  </Link>

                </article>

              </div>

            </div>

          </section>

            <section className="kj-customer-stories" aria-labelledby="kj-customer-stories-title">
              <div className="kj-contact-shell">
                <header className="kj-customer-stories__heading">
                  <div>
                    <span className="kj-contact-eyebrow">
                      Customer Stories
                    </span>
                    <h2 id="kj-customer-stories-title">
                      Câu chuyện khách hàng.
                    </h2>
                  </div>

                  <p>
                    Những khoảnh khắc thật trong quá trình King Jades lắng nghe,
                    tư vấn và đồng hành cùng khách hàng khi lựa chọn món ngọc phù hợp.
                  </p>
                </header>

                <div className="kj-customer-stories__grid">
                  {customerStories.map((story) => (
                    <article
                      className="kj-customer-story-card"
                      key={story.number}
                    >
                      <figure className="kj-customer-story-card__media">
                        <img
                          src={story.image}
                          alt={story.alt}
                          loading="lazy"
                          decoding="async"
                        />

                        <span className="kj-customer-story-card__number">
                          {story.number}
                        </span>
                      </figure>

                      <div className="kj-customer-story-card__content">
                        <span>King Jades Experience</span>
                        <h3>{story.title}</h3>
                        <p>{story.text}</p>
                      </div>
                    </article>
                  ))}
                </div>
              </div>
            </section>

        </main>

      </div>



      <Footer />

    </>

  );

};



export default ContactPage;